"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { getConsentStatus, trackPageView } from "@/utils/analytics";

const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GOOGLE_ID;

export default function GoogleAnalytics() {
  const pathname = usePathname();
  const previousPathname = useRef(pathname);
  const [consentLoaded, setConsentLoaded] = useState(false);
  const [initialConsent, setInitialConsent] = useState<"granted" | "denied">("denied");

  useEffect(() => {
    const status = getConsentStatus();
    setInitialConsent(status === "granted" ? "granted" : "denied");
    setConsentLoaded(true);
  }, []);

  useEffect(() => {
    if (previousPathname.current !== pathname) {
      previousPathname.current = pathname;
      trackPageView(pathname);
    }
  }, [pathname]);

  if (!GA_MEASUREMENT_ID || !consentLoaded) return null;

  return (
    <>
      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('consent', 'default', {
              analytics_storage: '${initialConsent}',
              wait_for_update: 500
            });
            gtag('js', new Date());
            gtag('config', '${GA_MEASUREMENT_ID}', {
              page_path: window.location.pathname
            });
          `,
        }}
      />
      <Script
        id="gtag-link"
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
      />
    </>
  );
}
